import { ESuburbanWCType } from '../../../../../../../packages/JsonQuery';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanBathroomFilter } from 'shared/selectors/advancedFilters';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';

export const SuburbanBathroomContainer: FC = () => {
  const { label, value, options } = useSelector(selectSuburbanBathroomFilter);

  const onChange = useFilterChangeCallback();

  const handleSuburbanBathroomTypesChange = useCallback(
    (newValue: ESuburbanWCType | null) => {
      onChange({ action: 'setSuburbanBathroomType', arguments: [newValue] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter
        value={value}
        options={options}
        onFilterChange={handleSuburbanBathroomTypesChange}
      />
    </AdvancedFilterRow>
  );
};
